/* eslint-disable @typescript-eslint/no-empty-function */
import { CommonModule } from '@angular/common';
import { booleanAttribute, Component, input, model } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export type RadioOption = {
    label: string;
    description?: string;
    value: any;
    disabled?: boolean;
};

@Component({
    selector: 'app-radio',
    templateUrl: './radio.component.html',
    standalone: true,
    imports: [CommonModule],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: Radio,
            multi: true,
        },
    ],
})
export class Radio implements ControlValueAccessor {
    options = input<RadioOption[]>([]);
    required = input<boolean, string>(false, { transform: booleanAttribute });
    disabled = input<boolean, string>(false, { transform: booleanAttribute });
    class = input<string>('');
    name = input.required<string>();
    direction = input<'horizontal' | 'vertical'>('horizontal');

    value = model<any>();

    onChange = (value: any) => {};
    onTouched = () => {};

    writeValue(obj: any, ev?: Event): void {
        ev?.stopPropagation();
        this.value.set(obj);
    }
    registerOnChange(fn: any): void {
        this.onChange = fn;
    }
    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }
    setDisabledState?(disabled: boolean): void {}
}
